import { render } from "./Field.Checkbox.vue?vue&type=template&id=68455fc7&ts=true"
import script from "./Field.Checkbox.vue?vue&type=script&lang=ts"
export * from "./Field.Checkbox.vue?vue&type=script&lang=ts"

import exportComponent from "/mobefind/admin/auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__